document.querySelectorAll( '.b-header' ).forEach( ( block ) => {

	const mainNavWrapper = block.querySelector( '.js-main-nav-wrapper' );
	const extrasMobile = block.querySelector( '.js-main-nav-extras-mobile' );
	const topNavInner = block.querySelector( '.js-top-nav-inner' );
	const topNavInnerMobile = block.querySelector( '.js-top-nav-inner-mobile' );
	const headerSearch = block.querySelector( '.js-header-search' );
	const headerSearchLink = block.querySelector( '.js-header-search-link' );
	const mobileToggle = block.querySelector( '.js-nav-mobile-toggle' );
	const megaMenuDropdowns = block.querySelectorAll( '.js-megamenu-dropdown' );
	const megamenuDropdownsItems = block.querySelectorAll( '.js-megamenu-dropdown-item' );

	let lastScrollY = window.scrollY;

	mainNavWrapper.addEventListener( 'click', ( event ) => {

		const toggleButton = event.target.closest( '.js-megamenu-dropdown' );

		if ( !toggleButton ) {

			return;

		}

		event.preventDefault();
		event.stopPropagation();

		const navItem = toggleButton.closest( '.b-nav-item' );
		const dropdown = navItem.querySelector( '.js-megamenu-dropdown-item' );

		const isActive = toggleButton.classList.contains( 'active' );

		megaMenuDropdowns.forEach( ( btn ) => btn.classList.remove( 'active' ) );
		megamenuDropdownsItems.forEach( ( drop ) => {

			drop.classList.remove( 'active' );
			drop.style.maxHeight = '0';
			dropdown.style.height = '0';

		} );

		if ( !isActive && dropdown ) {

			toggleButton.classList.add( 'active' );
			dropdown.classList.add( 'active' );
			dropdown.style.maxHeight = `${dropdown.scrollHeight}px`;

			const h = block.classList.contains( 'hidden--half' )
				? block.offsetHeight / 2
				: block.offsetHeight;
			dropdown.style.height = `calc(100vh - ${h}px)`;

		}

	} );

	/**
	 * Creates a debounced function that delays invoking the given function
	 * until after the specified wait time has passed since the last call.
	 *
	 * @template {(...args: any[]) => any} F
	 * @param {F} func - The function to debounce.
	 * @param {number} [wait=150] - The delay in milliseconds.
	 * @return {(...args: Parameters<F>) => void} The debounced function.
	 */
	const debounce = ( func, wait = 150 ) => {

		let timeout;
		return ( ...args ) => {

			clearTimeout( timeout );
			timeout = setTimeout( () => func.apply( null, args ), wait );

		};

	};

	/**
	 * Moves all child nodes from one element to another.
	 *
	 * @param {HTMLElement | null} from - The element to move children from.
	 * @param {HTMLElement | null} to - The element to move children to.
	 * @return {void}
	 */
	const moveChildren = ( from, to ) => {

		if ( !from || !to ) {

			return;

		}
		while ( from.firstChild ) {

			to.appendChild( from.firstChild );

		}

	};

	/**
	 * Moves specific elements between desktop and mobile containers
	 * depending on the current viewport width.
	 *
	 * @return {void}
	 */
	const moveElements = () => {

		megamenuDropdownsItems.forEach( drop => {

			drop.style.maxHeight = '0';
			drop.classList.remove( 'active' );

		} );
		megaMenuDropdowns.forEach( btn => btn.classList.remove( 'active' ) );

		document.documentElement.classList.remove( 'no-scroll' );
		const viewport = window.innerWidth;

		if ( viewport <= 1199 ) {

			moveChildren( topNavInner, extrasMobile );
			moveChildren( headerSearch, topNavInnerMobile );


		} else {

			moveChildren( extrasMobile, topNavInner );
			headerSearch.appendChild( headerSearchLink );

		}

	};

	/**
	 * Handles header visibility and dropdown state on scroll.
	 */
	const handleScroll = () => {

		const currentScroll = window.scrollY;

		megaMenuDropdowns.forEach( item => item.classList.remove( 'active' ) );
		megamenuDropdownsItems.forEach( item => item.classList.remove( 'active' ) );

		if ( currentScroll < 200 ) {

			block.classList.remove( 'hidden' );
			block.classList.remove( 'hidden--half' );
			lastScrollY = currentScroll;
			return;

		}

		if ( currentScroll > lastScrollY ) {

			block.classList.add( 'hidden' );
			block.classList.remove( 'hidden--half' );

		} else {

			block.classList.add( 'hidden--half' );
			block.classList.remove( 'hidden' );

		}

		lastScrollY = currentScroll;

	};

	document.addEventListener( 'keydown', ( event ) => {

		if ( event.key === 'Escape' || event.key === 'Esc' ) {

			megaMenuDropdowns.forEach( ( btn ) => btn.classList.remove( 'active' ) );
			megamenuDropdownsItems.forEach( ( drop ) => drop.classList.remove( 'active' ) );

		}

	} );

	document.addEventListener( 'click', ( event ) => {

		if ( !block.contains( event.target ) ) {

			megaMenuDropdowns.forEach( ( btn ) => btn.classList.remove( 'active' ) );
			megamenuDropdownsItems.forEach( ( drop ) => drop.classList.remove( 'active' ) );

		}

	} );

	mobileToggle.addEventListener( 'click', ( event ) => {

		event.preventDefault();
		event.stopPropagation();

		mobileToggle.classList.toggle( 'active' );

		if ( mobileToggle.classList.contains( 'active' ) ) {

			document.documentElement.classList.add( 'no-scroll' );
			mainNavWrapper.classList.add( 'active' );

		} else {

			document.documentElement.classList.remove( 'no-scroll' );
			mainNavWrapper.classList.remove( 'active' );

		}

	} );

	moveElements();

	window.addEventListener( 'resize', debounce( moveElements, 200 ) );
	window.addEventListener( 'scroll', debounce( handleScroll, 50 ) );

} );
